export default __webpack_public_path__ + "static/white-panel-a919895e3103b35ddfbeea7f960279c1.png";